import React from "react";
import { FiCpu, FiAlertCircle, FiLoader, FiSkipForward } from "react-icons/fi";

export default function ProcessStep({
  NavigationButtons,
  processGeneration,
  processDisplayRowsOrdered,
  processRows,
  processSourceRowsForDisplay,
  processVaultRowsForDisplay,
  processSourceRowsById,
  renderDocumentStyleSurface,
  onSkipVocabulary,
}) {
  const processTotal = processGeneration.totalRows || processRows.length || 0;
  const processGenerated = Math.min(processGeneration.generatedRows || 0, processTotal || processGeneration.generatedRows || 0);
  const processProgress = processTotal > 0
    ? Math.round((processGenerated / processTotal) * 100)
    : (processGeneration.running ? 0 : 100);
  const showPageLoader = processGeneration.running && processGenerated <= 0;

  return (
    <div className="wizard-step-content">
      {showPageLoader && (
        <div className="vault-api-loader-overlay" role="status" aria-live="polite" aria-label="Generating Content In Progress">
          <div className="vault-api-loader-card">
            <span className="vault-api-loader-spinner spinner" />
            <span className="vault-api-loader-text">Generating Content - In Progress</span>
          </div>
        </div>
      )}
      <div className="step-header-with-nav">
        <div className="step-header-left">
          <div className="step-icon-wrapper">
            <FiCpu className="step-icon" />
          </div>
          <div className="step-header-text">
            <h2 className="step-title">Process - Vault CRM Transformation</h2>
            <p className="step-subtitle">Veeva Content - Original vs Vault Content - AI Enhanced</p>
          </div>
        </div>
        <NavigationButtons
          prependActions={
            onSkipVocabulary && (
              <button
                className="step-nav-btn secondary"
                onClick={onSkipVocabulary}
                disabled={processGeneration.running || processRows.length === 0}
                title="Skip Vocabulary step and go directly to Compare"
              >
                <FiSkipForward /> Skip to Compare
              </button>
            )
          }
        />
      </div>

      <div className="form-section">
        {(processGeneration.running || processDisplayRowsOrdered.length > 0) && (
          <div className={`process-progress-card${processGeneration.running ? " running" : ""}`} role="status">
            <div className="process-progress-header">
              <span className="process-progress-title">
                {processGeneration.running ? (
                  <>
                    <FiLoader className="spinner" /> Generating Content - In Progress
                  </>
                ) : (
                  "Generating Content - Complete"
                )}
              </span>
              <span className="process-progress-count">
                {processGenerated}/{processTotal || 0}
              </span>
            </div>
            <div className="process-progress-track" aria-hidden="true">
              <div
                className={`process-progress-fill${processGeneration.running ? " is-running" : ""}`}
                style={{
                  width: `${Math.min(100, Math.max(0, processProgress))}%`,
                }}
              />
            </div>
          </div>
        )}

        {processDisplayRowsOrdered.length === 0 ? (
          <div className="reference-note" role="status">
            <FiAlertCircle className="note-icon" />
            <p>No document rows found. Go back to Documents and upload/read the content again.</p>
          </div>
        ) : (
          <div className="process-document-compare-scroll">
            <div className="process-document-compare-grid">
              <div className="process-document-panel">
                <div className="process-document-panel-title">Veeva Content - Original</div>
                {renderDocumentStyleSurface(processSourceRowsForDisplay, "process-source", { includeEmptyRows: true })}
              </div>
              <div className="process-document-panel">
                <div className="process-document-panel-title">Vault Content - AI Enhanced</div>
                {renderDocumentStyleSurface(processVaultRowsForDisplay, "process-vault", {
                  diffBaseRowsById: processSourceRowsById,
                  enableDiffHighlight: true,
                  includeEmptyRows: true,
                })}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
